module.exports = __webpack_public_path__ + "img/product-delay-happen-bg-icon.3af324da.png";